import { z } from "zod";

export const transitNumber = () =>
  z
    .string()
    .length(5, { message: "Transit number must be exactly 5 digits long" });
